import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import StoreInfoForm from "../../../Components/stores/storesStore/StoreInfoForm";
import HeaderBar from "../../../Components/UI/headerbar";
import NavTabsBar from "../../../Components/UI/navtabsbar";
import { showStores, updateStore } from "../../../MyApi/stores";
import LoadingSpinner from "../../../Components/UI/spinner";
import i18next from "i18next";

const StoreEditPage = () => {
 const location =useLocation()
    const tabs = [

    { key: "store_info", label: "معلومات المتجر", permission:"update_store" },
  ];
  const { id } = useParams();
  const queryClient =useQueryClient()
  const lang =i18next.language
  const [activeTab, setActiveTab] = useState("store_info");
  const [selectedLangCode, setSelectedLangCode] = useState(lang);

  const [errorMessage, setErrorMessage] = useState({});
  const [locationError, setLocationError] = useState(null);
  const mode = "edit";


  const { data, isLoading, refetch } = useQuery(["showStores", id ,selectedLangCode], () =>
    showStores(id ,selectedLangCode)
  );

  const stores = data?.data?.Store || {};


  const [address, setAddress] = useState({
    country_id:null,
    city_id:null,
    governorate_id:null,
    zone_id: null,
    latitude: null,
    longitude: null,
    zones_to_cover: [],
  });



  const mutation = useMutation({
    mutationKey: ["updateStore"],
    mutationFn: (postData) => updateStore(postData, id),
    onSuccess: (data) => {
      toast.success(data.message);
      queryClient.invalidateQueries("stores")
    }, 
    onError: (error) => {
      const statusError = error?.response?.status;
      const errorData = error?.response?.data?.data;

      console.log("❌ Validation Error:", errorData);

      toast.error("تحقق من البيانات المطلوبة");

      if (statusError === 422 && errorData) {
        setErrorMessage(errorData);
        const hasVendorError = Object.keys(errorData).some((key) =>
          key.startsWith("vendor.")
        );

        if (hasVendorError) {
          setActiveTab("owner_info");
        }
      }
    },
  });

  const onTabChange = (tabKey) => {
    setActiveTab(tabKey);
  };

  const handleAddStore = (storeData, working_days) => {
    const formData = new FormData();

    if (address.latitude === null || address.longitude === null) {
      console.log("validate");
      setLocationError((prev) => ({
        ...prev,
        location: "يرجي إدخال موقع علي الخريطة",
      }));
    }

    Object.keys(storeData).forEach((key) => {
      const value = storeData[key];
          if (
    (key === "logo" || key === "cover_image") &&
    typeof value === "string" &&
    value.startsWith("https")
  ) {

    return;
  }
      formData.append(`store[${key}]`, value);
    });
    
    // Add owner_id if it exists
    if (storeData.owner_id) {
      formData.append('store[owner_id]', storeData.owner_id);
    }
    
    Object.keys(address).forEach((key) => {
      if (key === "zones_to_cover") return;
      formData.append(`address[${key}]`, address[key]);
    });

    address.zones_to_cover.forEach((zone, i) => {
      formData.append(`zones_to_cover[${i}]`, zone);
    });
    // address.zones_to_cover.forEach((zones, i) => {
    //   formData.append(`zones_to_cover[${i}]`, zones);
    // });
    formData.append("_method", "PUT");
    working_days.forEach((work, i) => {
      formData.append(`working_days[${i}][day_of_week]`, work.day_of_week);
      formData.append(`working_days[${i}][open_time]`, work.open_time);
      formData.append(`working_days[${i}][close_time]`, work.close_time);
    });
    mutation.mutate(formData);
  };

const page= location?.state?.page ||1
  return (
    <div>
  
      <HeaderBar
        title="تعديل متجر"
        content=" عدل متجرًا مضافا بمعلومات المالك."
        isBack={true}
        isEdit={true}
        setSelectedLangCode={setSelectedLangCode}
        selectedLangCode={selectedLangCode}
         indexPath={`/stores?page=${page}`}
        page={page}
      />

      <div className="container">
        <div className="card rounded-4">
          <div className="card-body">
            <NavTabsBar
              tabs={tabs}
              activeTab={activeTab}
              onTabChange={onTabChange}
              
            />

            <StoreInfoForm
              stores={stores}
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
              locationError={locationError}
              setLocationError={setLocationError}
              onSave={handleAddStore}
              isLoadingMutate={mutation.isLoading}
              isLoading={isLoading}
              setAddress={setAddress}
              address={address}
              isShowComponent={activeTab === "store_info"}
              mode={mode}
              data={data}
     store_id={id}
            /> 
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoreEditPage;
